import { render, staticRenderFns } from "./OrderShipped.vue?vue&type=template&id=c2cc8496&scoped=true"
import script from "./OrderShipped.vue?vue&type=script&lang=js"
export * from "./OrderShipped.vue?vue&type=script&lang=js"
import style0 from "./OrderShipped.vue?vue&type=style&index=0&id=c2cc8496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cc8496",
  null
  
)

export default component.exports